<template>
  <van-tabbar route class="app-tabbar">
    <van-tabbar-item to="/index">
      <div class="tab-item">
        <img :src="$route.path === '/index' ? icons.home.active : icons.home.normal" />
        <span>首页</span>
      </div>
    </van-tabbar-item>

    <van-tabbar-item to="/cart" :badge="cartCount > 0 ? cartCount : ''">
      <div class="tab-item">
        <img :src="$route.path === '/cart' ? icons.book.active : icons.book.normal" />
        <span>书篮</span>
      </div>
    </van-tabbar-item>

    <van-tabbar-item to="/user">
      <div class="tab-item">
        <img :src="$route.path === '/user/index' ? icons.user.active : icons.user.normal" />
        <span>我的</span>
      </div>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
export default {
  data() {
    return {
      icons: {
        home: {
          normal: require("@/assets/mimages/tabbar/home.png"),
          active: require("@/assets/mimages/tabbar/home-h.png"),
        },
        book: {
          normal: require("@/assets/mimages/tabbar/cart.png"),
          active: require("@/assets/mimages/tabbar/cart-h.png"),
        },
        user: {
          normal: require("@/assets/mimages/tabbar/mine.png"),
          active: require("@/assets/mimages/tabbar/mine-h.png"),
        },
      },
    };
  },
  computed: {
  /** 购物车数量 */
  cartCount() {
    return this.$store.state.cart.cart.length;
  },
},
};
</script>
<style lang="less" scoped>
.app-tabbar {
  width: 100%;
  height: 64px!important;
  box-sizing: border-box;
  background: #FFFDF9;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border: 0px;
  margin: 0;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);

  .van-tabbar-item {
    padding: 0;
  }

  .tab-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 13px;
    color: #999;
    
  }
.van-tabbar-item--active{
  background: transparent!important;
}
  .van-tabbar-item--active .tab-item {
    color: #f6b300;
  }

  img {
    width: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/AppTabbar.vue